import * as React from 'react'
import { useLoaderData } from 'react-router-dom'

import { Button } from 'sdk/button/Button'
import { Content } from 'sdk/components'
import { ContactUs } from 'sdk/contact-us/ContactUs'

import { Hero } from './sections/hero/Hero'
import { TechnicalOverviewSection } from './sections/technical-overview/TechnicalOverviewSection'
import { GPUAccelerationSection } from './sections/gpu-acceleration/GPUAccelerationSection'
import { TechnologicalFirstSection } from './sections/technological-first/TechnologicalFirstSection'
import { DocumentationSection } from './sections/documentation/DocumentationSection'
import { DeveloperNewsSection } from './sections/developer-news/DeveloperNewsSection'
import { TieredPlansSection } from './sections/tiered-plans/TieredPlansSection'
import { PartnerProgramSection } from './sections/partner-program/PartnerProgramSection'

import styles from './ResourcesPage.module.scss'

import type { ResourcesPageLoaderData } from './interfaces'

const isExternalUrl = (url: string): boolean => /^(https?:\/\/|mailto:|tel:)/.test(url)

export const ResourcesPage: React.FC = () => {
  const { newsfeed, cmsContent } = useLoaderData() as ResourcesPageLoaderData

  if (!cmsContent) {
    throw new Error('Resources CMS content missing')
  }

  const isExternalContactUrl = isExternalUrl(cmsContent.contact.buttonUrl)

  return (
    <>
      <Hero className={styles.heroWrapper} content={cmsContent.hero} />
      <Content gap={150}>
        <TechnicalOverviewSection content={cmsContent.technicalOverview} />
        <GPUAccelerationSection content={cmsContent.gpuAcceleration} />
        <TechnologicalFirstSection content={cmsContent.technologicalFirst} />
        <DocumentationSection content={cmsContent.documentation} />
        <DeveloperNewsSection newsfeed={newsfeed} />
        <TieredPlansSection content={cmsContent.tieredPlans} />
        <PartnerProgramSection content={cmsContent.partnerProgram} />
        <ContactUs
          text={cmsContent.contact.text}
          button={(
            <Button
              as={isExternalContactUrl ? 'link' : 'router-link'}
              href={isExternalContactUrl ? cmsContent.contact.buttonUrl : undefined}
              to={!isExternalContactUrl ? cmsContent.contact.buttonUrl : undefined}
              target={isExternalContactUrl ? '_blank' : undefined}
            >
              {cmsContent.contact.buttonText}
            </Button>
          )}
        />
      </Content>
    </>
  )
}
